export function getFormattedDebitorId(debitorId: string){
  if (debitorId) {
    if (debitorId.length < 8) {
      return debitorId
    }

    const debitorFormatTest = new RegExp(/[\w\d]+\_[\d]+/);
    if (debitorFormatTest.test(debitorId) === true) {
      const debitorSplit = debitorId.split('_');
      debitorId = debitorSplit[1];
    }

    const firstPart = debitorId.substring(0,2)
    const secondPart = debitorId.substring(2,5)
    const thirdPart = debitorId.substring(5,9)

    return firstPart + '/' + secondPart + '/' + thirdPart
  }
  return ''
}
